/**
 * Rotas da aplicação, alinhadas com a estrutura de Menu/Submenu do back
 * (ControleAcessoContext.HasData). Regra: menu que tem submenus → o submenu vira
 * `/menu/submenu`. Menu direto (link próprio) → `/menu`.
 *
 * Exceções intencionais (aguardando alinhamento com cliente):
 *   - `usuarios` / `importarUsuarios` / `perfis` continuam na raiz em vez de
 *     `/usuarios/...` para evitar `/usuarios/usuarios`.
 *   - `concessionarias` continua na raiz pelo mesmo motivo.
 *
 * Páginas sem implementação foram removidas — quando entrarem, basta adicionar o
 * PATH aqui e a rota correspondente no AppRoutes. O Sidebar lê do back e filtra
 * submenus sem mapping em `LINK_TO_PATH`, então itens sem PATH não aparecem.
 */
export const PATHS = {
  // Raiz
  dashboard: "/dashboard",
  meuPerfil: "/meu-perfil",

  // Compras
  fornecedores: "/compras/fornecedores",
  pedidosCompra: "/compras/pedidos-compras",
  recebimento: "/compras/recebimento",

  // Ocorrências
  ocorrencias: "/ocorrencias",

  // Estoque
  produtos: "/estoque/produtos",
  inventarios: "/estoque/inventarios",
  movimentacoes: "/estoque/movimentacoes",
  posicaoEstoque: "/estoque/posicao-estoque",
  recebimentosTransferencia: "/estoque/recebimentos-transferencia",
  rastreamentoEtiquetas: "/estoque/rastreamento-etiquetas",

  // Gestão de Vendas
  simulacoesVenda: "/gestao-vendas/simulacoes",
  pedidosVenda: "/gestao-vendas/pedidos-venda",
  vendas: "/gestao-vendas/vendas",
  dashboardVendas: "/gestao-vendas/vendas/dashboard",

  // Instalação
  agenda: "/instalacao/agenda",
  minhasOs: "/instalacao/minhas-os",
  inspecaoQualidade: "/instalacao/inspecao-qualidade",
  indicadoresQualidade: "/instalacao/indicadores-qualidade",
  garantiaTerceiro: "/instalacao/garantia-terceiro",

  // Comissões
  precosPorLoja: "/comissoes/precos-por-loja",
  comissionados: "/comissoes/comissionados",
  regrasComissao: "/comissoes/regras-comissao",
  campanhasIncentivo: "/comissoes/campanhas-incentivo",
  valoresInstalacao: "/comissoes/valores-instalacao",
  pagamentoComissao: "/comissoes/pagamento-comissao",
  aprovacaoComissao: "/comissoes/aprovacao-comissao",

  // Fiscal
  dashboardFiscal: "/fiscal/dashboard-fiscal",
  regrasTributacao: "/fiscal/regras-tributacao",
  apuracaoIRPJeCSLL: "/fiscal/apuracao-irpj-csll",
  relatorioFiscal: "/fiscal/relatorio-fiscal",

  // Concessionárias
  concessionarias: "/concessionarias",

  // Empresas
  empresas: "/empresas",

  // Auditoria
  auditoria: "/auditoria",

  // Usuários
  usuarios: "/usuarios",
  importarUsuarios: "/importar-usuarios",
  perfis: "/perfis",

  // Configurações
  whitelistDominios: "/configuracoes/whitelist-dominios",
  politicaSenhas: "/configuracoes/politica-senhas",
  configuracaoSessao: "/configuracoes/configuracoes-sessao",
  marcas: "/configuracoes/marcas",
  categoriasProduto: "/configuracoes/categorias-produto",
  categoriasFornecedor: "/configuracoes/categorias-fornecedor",
  regrasCompras: "/configuracoes/regras-compras",

  // Auth (fora da árvore de menus)
  primeiroAcesso: "/primeiro-acesso",
  redefinirSenhaLink: "/redefinir-senha",

  // Páginas públicas (acessíveis sem login via link de e-mail)
  confirmarRecebimento: "/confirmar-recebimento",
} as const;
